import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ImageComponent from 'common/Image';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 370px;
  max-height: 400px;
  height: fit-content;
  color: black;
  border-radius: 5px;
  width: 100%;
  margin: 10px;
`;
export const Image = styled(ImageComponent)`
  max-width: 360px;
  height: 280px;
  align-self: center;
  width: 100%;
  margin: auto;
  background-size: cover;
`;

export const Description = styled.p`
  height: fit-content;
  margin: 0.5rem;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
`;

export const Remove = styled(FontAwesomeIcon)`
  font-size: 32px;
  cursor: pointer;
  &:hover {
    & > path {
      transition-duration: 0.2s;
      fill: red;
    }
  }
`;

export const Header = styled.h3`
  font-size: 20px;
  line-height: 24px;
  margin: 6px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 900;
`;

export const Link = styled.a`
  color: inherit;
  text-decoration: inherit;
  width: 100%;
  align-self: center;
`;
